<template>
<div id="layout-factura-" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Reporte de Facturas" class="elevation-1 px-5 py-3" >
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>
                        <v-tab key="carga_layout">Cargar Datos Facturas sin XML</v-tab>
                        <v-tab key="generar_reporte">Reporte de Facturas</v-tab>
                        
                        <v-tab-item key="carga_layout" >
                            <div class="contenedor-tab-reportes" >
                                <v-card-text>
                                <v-card-title>
                                    <span class="headline" ></span>
                                </v-card-title>
                                
                                </v-card-text>
                                
                                <v-card-text>
                                    <v-row>
                                        <v-col sm="6" md="6" lg="6" >
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    1.- Descargar Layout Datos de Factura:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout_Facturas.xlsx" >
                                                    <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                                        <v-icon dark>receipt</v-icon>
                                                    </v-btn>
                                                </exportar-excel>
                                                </v-col>                                        
                                            </v-row>                                        
                                            <v-row>
                                                <v-col sm="10" md="10" lg="10" >
                                                    2.- Carga de Layout de Factura:
                                                </v-col>
                                                <v-col sm="1" md="1" lg="1" >
                                                    <upload-excel-component idInput="pedimentosKey" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                </v-col>                                                
                                            </v-row>
                                        </v-col>                                        
                                    </v-row>
                                                                    
                                </v-card-text>

                                <!--v-card-text>                                
                                    <v-refresh-button :funcion="cargar" />

                                    <v-client-table ref="vuetable" :data="datos" :columns="columns_datos" :options="options_datos" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="secondary" title="Descagar Proforma" 
                                            v-if="props.row.pdf!=undefined && props.row.pdf!=''" @click="downloadReporte(props.row.pdf)" >
                                            <v-icon dark>mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                        
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarLayout(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                                </v-card-text-->
           

                            </div>     
                        </v-tab-item>
                        <v-tab-item key="generar_reporte" >
                            <br>
                            <v-card-text>
                                <v-form ref="form">
                                <v-row row wrap>
                                    <v-col sm="12" md="4" lg="4" >
                                    
                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_de" clearable label="Fecha Pedimento Inicial" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_de = parseDate(model_busqueda.fecha_de)" v-mask="'####-##-##'"
                                            :rules="[verificaPedimento, $rules.validaDiasConsulta(model_busqueda.fecha_de, model_busqueda.fecha_a), validaAnio, validaFecha]" ></v-text-field>
                                        </template>

                                        <v-date-picker v-model="model_busqueda.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu1 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                    </v-col>
                                    <v-col sm="12" md="4" lg="4" >
                                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }" >
                                        <v-text-field v-on="on" v-model="model_busqueda.fecha_a" clearable label="Fecha Pedimento Final" color="secondary" prepend-icon="event" @blur="model_busqueda.fecha_a= parseDate(model_busqueda.fecha_a)" v-mask="'####-##-##'"
                                            :rules="[verificaPedimento, $rules.validaDiasConsulta(model_busqueda.fecha_de, model_busqueda.fecha_a), validaAnio, validaFecha]" ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model_busqueda.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                        <v-spacer />

                                        <v-btn color="secondary" x-small @click="menu2 = false" >
                                            Cancelar
                                        </v-btn>
                                        </v-date-picker>
                                    </v-menu>

                                    </v-col>
                                    <v-col sm="12" md="4" lg="4" >                                       
                                        <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                        <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                        </v-btn>                  
                                    </v-col>
                                </v-row>    
                                <v-row row wrap>
                                    <v-col>
                                        Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                    </v-col>
                                </v-row>
                                <v-row row wrap>
                                    <v-col sm="12" md="10" lg="10">
                                        <v-combobox v-model="lista_filtrada" label="Lista de Pedimentos" multiple persistent-hint small-chips disabled color="green">
                                        </v-combobox>
                                    </v-col>
                                </v-row>

                                </v-row>
                                </v-form>
                                
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="info" @click="generar_reporte_sqs()" >
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>
                                
                            </v-card-actions>
                            </v-card-text>
                            

                            <v-card-text>
                                <v-refresh-button :funcion="cargar_reportes" />
                                <v-client-table ref="vuetable" :data="reportes" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props" >
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)">
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" @click="eliminarReporte(props.row.id)" >
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    </v-client-table>
                            </v-card-text>


                        </v-tab-item>
                    </v-tabs>                                                                   
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

   <v-dialog v-model="dialog1" max-width="500px">
    <v-card>
      <v-card-text>
        <h5>Ingrese lista de pedimentos</h5>
        <span>Uno por línea con formato: 000-0000-0000000</span><br>
        <small>*Usando esta opción no se tomará en cuenta el rango de fechas</small>
        <v-form ref="formListado" lazy-validation="">
          <v-textarea outlined rows="15" v-model="model_busqueda.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click="model_busqueda.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
        <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },

data: () => ({
        dialog1: false,
        lista_filtrada: [],
        emisores: [],
        file_adjunto: null,
        estatus_arr:["ACTIVO","INACTIVO"],
        password:"",
        con_password:0,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        URL:"",        
        data_resumen:[],
        
        columns_resumen: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento",
            "no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
        options_resumen: {
            filterable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia"
            ,"error","URL"],
            sortable: ["tipo_operacion","patente","seccion_aduanera","pedimento","fecha_pago_real",
            "fecha_entrada","anio","clave_documento","no_maquina","linea","marca","modelo","descripcion","serie","observaciones","edificio","estatus","planta_referencia","error","URL"],
            headings: {
                tipo_operacion:"Tipo Operacion",
                patente:"patente",
                seccion_aduanera:"Sección Aduanera",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                fecha_entrada:"Fecha Entrada",
                anio:"Año",
                clave_documento:"Clave Documento",
                "no_maquina":"Maquina No.",
                "planta_referencia":"Planta",
                marca:"Marca",
                modelo:"Modelo",
                serie:"Serie",
                informacion:"Información",
                error:"Error",
            }
        },
        modal_pedimentos:false,
        permisoEliminar: false,
        menu1: false,
        menu2: false,
        plantas_arr: [],
        edificios_arr: [],
        lineas_arr: [],
        codigo_qr:"",
        modal:false,
        modal_qr:false,
        model_editable:{
            pedimento: "",
            anio: "",
            no_maquina: "",
            linea: "",
            marca: "",
            modelo: "",
            descripcion: "",
            serie: "",
            observaciones: "",
            edificio: "",
            estatus: "",
            planta_referencia:""
        },
        model_busqueda:{
            rfc:"",
            usuario: "",
            fecha_de:"",
            fecha_a:"",   
            lista: "",                   
            reporte_url: "/reportes_ws/reporte_facturas_balluf/",
            nombre_reporte: "Reporte de Facturas",
            tipo: "Rpt_Facturas_Balluf",
        },
        name: "datagrid",        
        arrClaves:[],        
        URL: "",

        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reportes",
                disabled: true,
                to: ""
            },
            {
                text: "Reporte de Facturas",
                disabled: true,
                to: ""
            }
        ],
        loadingPlantas:false,
        loadingEdificios:false,
        loadingLineas:false,
        datos: [],
        columns_datos: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf", "actions"],
        options_datos: {
            filterable: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf"],
            sortable: ["id", "created_at", "iniciales", "factura", "fecha_factura", "empresa_destino", "error_pdf"],

            headings: {
                id: "No. Proceso",
                created_at: "Solicitado",
                iniciales: "Usuario",
                factura: "Factura",            
                fecha_factura: "Fecha Factura",
                empresa_destino: "Empresa Destino",
                error_pdf: "Error PDF",
                actions: "Opciones"
            }
        },
        reportes:[],
        columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],
            sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "fecha_generacion", "estatus", "error"],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",            
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        columnsEtiquetas: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error", "actions"],
        optionsEtiquetas: {
            filterable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],
            sortable: ["solicitado","usuario","planta_referencia", "no_maquina", "edificio", "linea", "fecha_pago_real", "pedimento","estatus","error"],

            headings: {
                "planta_referencia":"Planta", 
                "no_maquina":"No. Maquina", 
                "edificio":"Edificio", 
                "linea":"Línea", 
                "fecha_pago_real":"Fecha Pedimento", 
                "pedimento":"No. Pedimento",
                actions: "Opciones"
            }
        },
                
        
        encabezadoLayout: {
            "PEDIMENTO NUMBER":"PEDIMENTO NUMBER",
            "-":"-",
            "PROVEEDOR":"PROVEEDOR",
            "RFC":"RFC",
            "FACTURA":"FACTURA",
            "UUID":"UUID",
            "FECHA":"FECHA",
            "SUBTOTAL":"SUBTOTAL",
            "IVA":"IVA",
            "RET IVA":"RET IVA",
            "RET ISR":"RET ISR",
            "TOTAL":"TOTAL",
            "MONEDA":"MONEDA",
            "SALDO A PAGAR":"SALDO A PAGAR",            
        },
        
        camposLayout: [{
            "PEDIMENTO NUMBER":"[Número de Pedimento en formato: 25 24 3953 5000505]",
            "-":"[Número de Pedimento en formato: 240-3953-5000505]",
            "PROVEEDOR":"[Nombre del Proveedor]",
            "RFC":"[RFC del Proveedor]",
            "FACTURA":"[Número de Factura]",
            "UUID":"[UUID de la Factura - OPCIONAL]",
            "FECHA":"[Fecha de Factura en formato dd/mm/aaa]",
            "SUBTOTAL":"[Subtotal]",
            "IVA":"[IVA]",
            "RET IVA":"[IVA Retenido]",
            "RET ISR":"[ISR Retenido]",
            "TOTAL":"[Total]",
            "MONEDA":"[Moneda]",
            "SALDO A PAGAR":"[Saldo a Pagar]",
        },
        {
            "PEDIMENTO NUMBER":"Ingresar información a partir de esta fila (3ra fila) en adelante",
        }
        ],
        camposObligatorios: [
            "PEDIMENTO NUMBER",
            "-",
            "PROVEEDOR",
            "RFC",
            "FACTURA",            
            "FECHA",
            "SUBTOTAL",
            "IVA",
            "RET IVA",
            "RET ISR",
            "TOTAL",
            "MONEDA",
            "SALDO A PAGAR",            
        ],        
    }),
    methods: {
        setListValues: function() {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model_busqueda.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                continue;
                } else {
                this.lista_filtrada.push(to_list[i]);
                }
            }
            this.model_busqueda.fecha_de = "";
            this.model_busqueda.fecha_a = "";
            this.dialog1 = !this.dialog1;
        },
        get_array_lista: function(cadena) {
            try {
                var newarr = [];
                if (cadena != undefined) {
                let data = cadena.split("\n");
                newarr = data.filter(a => a.trim() !== '');
                for (var i = 0; i < newarr.length; i++) {
                    newarr[i] = newarr[i].trim();
                    newarr[i] = newarr[i].replace(',', '');
                    newarr[i] = newarr[i].replace('.', '');
                }
                }
                return newarr;
            } catch (error) {
                console.log(error);
            }
        },
        verificaPedimento: function() {
            if (this.model_busqueda.lista != '' && this.model_busqueda.lista != null && this.model_busqueda.lista.length > 0) {
                return true;
            }
            if (this.model_busqueda.fecha_de == "" || this.model_busqueda.fecha_a == "") {
                return "Favor de ingresar fechas o listado de pedimentos";
            }
            return true;
        },
        maxListaRule: function() {
            if (this.model_busqueda.lista == '' || this.model_busqueda.lista == undefined || Array.isArray(this.model_busqueda.lista)) {
                return "Lista vacia";
            }

            let x = this.model_busqueda.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            } else if (x.length > 0) {
                for (var k in x) {
                if (!this.validarPatronPedimento(x[k]))
                    return "Verificar pedimentos no válidos. Ejemplo correcto: 240-0123-0000123";
                }
            }

            return true;
        },
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."
            else
                return true;
        },
        validaAnio: function() {
            if (this.model_busqueda.fecha_de != "" && this.model_busqueda.fecha_a != "") {
                var inicio = moment(this.model_busqueda.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model_busqueda.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                self.file_adjunto = file;
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        
        validaEntero(numero){
            const pattern = /^[\d]*$/;
            return pattern.test(numero);
        },
        validaFloat: function(numero) {
            const pattern = /^\d*(\.\d*)?$/;
            return pattern.test(numero);
        },
        
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1 || results[campo].toString().trim()=="")
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        cargarEmisores: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.emisores = res.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err.response);
                    });
            }

        },
        get_emisor: function(rfc_emisor){
            var search = this.emisores.find(function (e) {
                return e.rfc.trim().toLowerCase() == rfc_emisor.toString().trim().toLowerCase();
            });
            if (search) {                
                var emisor = search;
                
                emisor["pais_nombre"] = "";
                if(emisor["pais"] != undefined && emisor["pais"] !=null){
                    emisor["pais_nombre"] = emisor["pais"]["clave_m3"];
                }

                emisor["estado_nombre"] = "";
                if(emisor["estado"] != undefined && emisor["estado"] !=null){
                    emisor["estado_nombre"] = emisor["estado"]["nombre"];
                }

                return emisor;
                
            } else
                return false;
        },        
        trimChar: function(str, charToRemove) {
            // Construye la expresión regular para buscar el carácter al inicio y al final
            const regex = new RegExp(`^${charToRemove}+|${charToRemove}+$`, 'g');
            // Usa replace para eliminar el carácter al inicio y al final
            return str.replace(regex, '');
        },
                
        validaCargaLayout: async function (results) {
            var self = this;
            //return new Promise(function(resolve, reject){
            var emisores = {};
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                    
                } else if (results.length > 1000){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 1000, favor de verificar.";                
                } else {
                    
                    for (var k in results) {                                                

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {
                            
                            if(results[k]["PEDIMENTO NUMBER"].trim().length != 18){
                                errores++;
                                errorTmp = '<br/>' + "- PEDIMENTO NUMBER '" + results[k]["PEDIMENTO NUMBER"] + "' no tiene longitud o formato válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(results[k]["-"].trim().length != 16){
                                errores++;
                                errorTmp = '<br/>' + "- La columna - '" + results[k]["-"] + "' no tiene longitud o formato válido.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            
                            var fechaOrig = results[k]["FECHA"];
                            results[k]["FECHA"] = this.parseDateExcel(results[k]["FECHA"]); 
                            
                            if (results[k]["FECHA"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La Fecha de factura '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }

                            if(results[k]['SUBTOTAL'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El Subtotal no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['SUBTOTAL'])){
                                errores++;
                                errorTmp = '<br/>' + "- El Subtotal '" + results[k]['SUBTOTAL'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            } else {
                                results[k]['SUBTOTAL'] = parseFloat(results[k]['SUBTOTAL']);
                            }

                            if(results[k]['IVA'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El IVA no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['IVA'])){
                                errores++;
                                errorTmp = '<br/>' + "- El IVA '" + results[k]['IVA'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['IVA'] = parseFloat(results[k]['IVA']);
                            }

                            if(results[k]['RET IVA'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El RET IVA no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['RET IVA'])){
                                errores++;
                                errorTmp = '<br/>' + "- El RET IVA '" + results[k]['RET IVA'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['RET IVA'] = parseFloat(results[k]['RET IVA']);
                            }

                            if(results[k]['RET ISR'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El RET ISR no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['RET ISR'])){
                                errores++;
                                errorTmp = '<br/>' + "- El RET ISR '" + results[k]['RET ISR'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['RET ISR'] = parseFloat(results[k]['RET ISR']);
                            }

                            if(results[k]['TOTAL'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El TOTAL no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['TOTAL'])){
                                errores++;
                                errorTmp = '<br/>' + "- El TOTAL '" + results[k]['TOTAL'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['TOTAL'] = parseFloat(results[k]['TOTAL']);
                            }
                            
                            if(results[k]['SALDO A PAGAR'].toString().trim() == ""){
                                errores++;
                                errorTmp = '<br/>' + "- El SALDO A PAGAR no debe estar vacío. Al menos debe ser cero.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!this.validaFloat(results[k]['SALDO A PAGAR'])){
                                errores++;
                                errorTmp = '<br/>' + "- El SALDO A PAGAR '" + results[k]['SALDO A PAGAR'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;                            
                            } else {
                                results[k]['SALDO A PAGAR'] = parseFloat(results[k]['SALDO A PAGAR']);
                            }

                                                                                  

                        }
                        
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                self.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            var importData = {"rfc":"", "facturas":[]};
            try {    
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var rfc = this.$local_storage.get("rfc");
                    var user = this.$local_storage.get("id_usuario");  
                    importData.rfc = rfc;
                    for (var k in results) { 
                        
                        importData["facturas"].push({
                            "rfc": rfc,
                            "usuario": user,
                            "pedimento": results[k]['PEDIMENTO NUMBER'],
                            "pedimento_econnect": results[k]['-'],
                            "proveedor": results[k]['PROVEEDOR'],
                            "rfc_proveedor": results[k]['RFC'],
                            "factura": results[k]['FACTURA'],
                            "uuid": results[k]['UUID']!=null ? results[k]['UUID'].toString() : "",
                            "fecha": results[k]['FECHA'],
                            "subtotal": results[k]['SUBTOTAL'],
                            "iva": results[k]['IVA'],
                            "iva_ret": results[k]['RET IVA'],
                            "isr_ret": results[k]['RET ISR'],
                            "total": results[k]['TOTAL'],
                            "moneda": results[k]['MONEDA'],
                            "saldo": results[k]['SALDO A PAGAR'],                            
                        });
                        
                    }

                    axios.post(this.$apiReportes + "reportes_ws/save_datos_factura_balluf/", importData)                    
                        .then((res) => {
                            
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La información se ha guardado correctamente.",
                                footer: ""
                            });                           

                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: ""
                            });                            
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            //this.cargar();      
                        });
                    
                }

            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        
        guardar_plantilla_s3: function(id_etiqueta){
            var self = this;
            var rfc = this.$local_storage.get("rfc"); 
            var keyFile = rfc + "/plantillas_activo_fijo/"+ id_etiqueta.toString() + "_"+ self.file_adjunto.name;
                    
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: self.file_adjunto.type
            }
            axios.post(self.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.file_adjunto, {headers:{'Content-Type': self.file_adjunto.type}})
                        .then((res) => { 
                            console.log("Archivo cargado correctamente a S3");
                        })                            
                        .catch((error)=>{                                                        
                            console.log("Error al cargar a S3: ", error);
                        });
                        
                    } else {
                        console.log("Undefined url de carga S3: ", res.data);
                    }
                })
                .catch((error) => {
                    console.log("Error al obtener url de carga S3: ", error);
            });
        },
        cargar: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc')                
            };
            axios.post(this.$apiReportes + "reportes_ws/consulta_factura_layout/", data)            
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.datos = res.data;
                this.datos.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.created_at) - new Date(a.created_at) ;
                });
                for (var k in this.datos) {
                    this.datos[k].created_at = this.parseDate(this.datos[k].created_at);
                    this.datos[k].fecha_factura = this.parseDate(this.datos[k].fecha_factura);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        cargar_reportes: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.$local_storage.get('rfc'),
                tipo: 'Rpt_Facturas_Balluf'
            };
            axios.post(this.URL + "get_reportes/", data)
            .then(res => {
            if (typeof res.data !== "undefined") {
                this.reportes = res.data;
                this.reportes.sort(function(a, b) {
                    //Ordenar por fecha más reciente
                    return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.reportes) {
                    this.reportes[k].fecha_solicitud = this.parseDate(this.reportes[k].fecha_solicitud);
                    this.reportes[k].fecha_generacion = this.parseDate(this.reportes[k].fecha_generacion);
                    this.reportes[k].estatus = this.getEstatus(this.reportes[k].estatus);                    
                }
            }
            })
            .catch(err => {
                console.log(err);
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los registros. Favor de intentar nuevamente.",
                    footer: "",
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        
        eliminarLayout: function (id_layout) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el registro con No. Proceso: "+id_layout+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id: id_layout,
                }
                axios.post(this.$apiReportes + 'reportes_ws/delete_factura_layout/', datos)                
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Intente nuevamente por favor.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();                        
                    });
              }
          });
        },
        generar_reporte_sqs() {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model_busqueda;   
                
                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    data['lista'] = this.get_array_lista(data['lista']);
                    data['fecha_de'] = ""
                    data['fecha_a'] = ""
                }
                
                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        //url: "http://127.0.0.1:7000/reportes_ws/reporte_facturas_balluf/",                        
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.cargar_reportes();
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar_reportes();
                    });
              }
          });
        },
        downloadReporte: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                if (typeof res.data !== 'undefined') {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = res.data.mensaje;
                    a.target = '_blank';
                    a.click();
                    a.parentNode.removeChild(a);

                } else {
                    this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                    footer: '',
                    });
                }
                })
                .catch((error) => {
                var mensaje = "Ocurrió un error al descargar el archivo";
                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                    mensaje = error.response.data.mensaje;
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: '',
                });
                console.log(error);
                }).then(() => {
                this.$root.$dialogLoader.hide();
                });
            },
                        
            
        
    }, //methods

    created: function () {    
        this.URL = this.$hostname+"reportes/";  
        this.model_busqueda.rfc = this.$local_storage.get("rfc");
        this.model_busqueda.usuario = this.$local_storage.get("id_usuario");  
        this.cargarEmisores();   
        //this.cargar();
        this.cargar_reportes();

    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
.elevation-1 .v-expansion-panel >>> .v-label.theme--light {
        color: black !important;
    }    

#html_codigo_qr {
  display: inline-block;
  height: auto;
}
#html_codigo_qr img {
  max-width: 100%;
}

</style>
